































import { defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { Ref } from '@vue/composition-api'
import { formFieldProps } from '~/constants/form'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'

export default defineComponent({
  components: { FieldError },
  props: formFieldProps,
  setup(props) {
    const { name, specs } = toRefs(props)

    const value = ref({})

    const widthError = ref(null)
    const heightError = ref(null)
    const error = ref(null)

    const formValidationBuilder = useDep(FormValidationBuilder)

    function onValue(v: Ref<string[]>) {
      value.value = v.value || {}
    }

    function onError(e: Ref<any>) {
      if (e.value?.width) {
        widthError.value = e.value.width
      }
      if (e.value?.width) {
        widthError.value = e.value.width
      }

      if (typeof e.value === 'string') {
        error.value = e
      }

      if (!e.value) {
        widthError.value = null
        heightError.value = null
        error.value = null
      }
    }

    const { valueChanged } = useClassifiedForm(props, {
      onValue,
      onError
    })

    const handleSpecChange = (n: string, v: number) => {
      const textAsNum = Number(v)

      const validator = formValidationBuilder.new(
        n === 'width' ? widthError : n === 'height' ? heightError : error
      )
      validator.required(specs.value[n]?.required, textAsNum)
      if (v !== undefined && specs.value[n].min && specs.value[n].max) {
        validator
          .isNumeric(textAsNum)
          .aboveMinNumber(specs.value[n].min, textAsNum)
          .belowMaxNumber(specs.value[n].max, textAsNum)
      }
      validator.validate()

      valueChanged(name.value, { ...value.value, [n]: v })
    }

    return { value, widthError, heightError, error, handleSpecChange }
  }
})
